export const _AUTH = {
	TOKEN_NAME: 'token',
	USERNAME: 'user',
	ROLE: 'role'
};
